import { createSelector } from 'reselect';
import precise from '../../src/modules/precise';
import getPenaltiesFromPipeAndWeight from '../../src/modules/getPenaltiesFromPipeAndWeight';

const selectedVehicleValueSel = state => state.registration.selectedVehicleValue;
const applyPenaltyFeeSel = state => state.registration.applyPenaltyFee;
const mobileHomeLengthSel = state => state.registration.mobileHomeLength;
const vehicleWeightSel = state => state.registration.vehicleWeight;
// const penaltyFeeSel = state => state.registration.penaltyFee;

const renewalPenaltyTotalSelector = createSelector(
  [selectedVehicleValueSel, applyPenaltyFeeSel, mobileHomeLengthSel, vehicleWeightSel],
  (pipe, applyPenaltyFee, mobileHomeLength, vehicleWeight) => {
    if (!applyPenaltyFee) {
      return precise(0);
    }
    const total = getPenaltiesFromPipeAndWeight(pipe, Number(vehicleWeight), applyPenaltyFee);
    return precise(Number(total) * mobileHomeLength);
  },
);

export default renewalPenaltyTotalSelector;



// WEBPACK FOOTER //
// ./src/selectors/renewalPenaltyTotal.selector.js